/* Product measurements: carry the customer's selected options into the contact form. */
if (!customElements.get('wdlt-measurements')) {
 customElements.define('wdlt-measurements', class extends HTMLElement {
  connectedCallback() {
   if(this.initialized) return;
   this.initialized=true;
   const link=this.querySelector('.wdlt-measurements-link');
   if(!link) return;
   this.querySelector('dialog')?.remove();
   link.removeAttribute('aria-haspopup');
   const info=this.closest('.product__info-container');
   const setup=()=>{
    const picks=Array.from(info.querySelectorAll('.size-options[data-opt]'));
    picks.forEach((pick,i)=>{
     const button=pick.querySelector('button');
     if(!button || pick.querySelector('.wdlt-option-label')) return;
     const label=document.createElement('label');
     label.className='wdlt-option-label';
     label.textContent=pick.dataset.opt.toLowerCase()==='size'?'Size':pick.dataset.opt;
     if(!button.id) button.id='wdlt-option-'+this.dataset.form+'-'+i;
     label.htmlFor=button.id;
     pick.before(label);
     pick.querySelector('ul')?.setAttribute('aria-labelledby',button.id);
    });
    const sizePick=picks.find(p=>p.dataset.opt.trim().toLowerCase()==='size') || picks[0];
    if(sizePick){
     const label=sizePick.previousElementSibling;
     const row=document.createElement('div');
     row.className='wdlt-size-heading-row';
     sizePick.before(row);
     if(label?.classList.contains('wdlt-option-label')) row.append(label);
     row.append(this);
    }
    const update=()=>{
     const variants=JSON.parse(this.dataset.variants||'[]');
     const values=picks.map(p=>p.querySelector('button').textContent.trim().replace(/ - Sold out$/i,''));
     const variant=variants.find(v=>v.options.every((o,i)=>o===values[i]));
     const productURL=new URL(this.dataset.url,location.origin);
     if(variant) productURL.searchParams.set('variant',variant.id);
     const url=new URL(link.getAttribute('href').split('?')[0],location.origin);
     url.searchParams.set('inquiry','measurements');
     url.searchParams.set('product',this.dataset.title);
     url.searchParams.set('product_url',productURL.pathname+productURL.search);
     url.searchParams.set('selection',picks.map((p,i)=>(p.dataset.opt.toLowerCase()==='size'?'Size':p.dataset.opt)+': '+values[i]).join(' / '));
     link.href=url.href;
    };
    update();
    this.observer=new MutationObserver(update);
    picks.forEach(p=>this.observer.observe(p.querySelector('button'),{childList:true,subtree:true,characterData:true}));
    link.addEventListener('click',update);
   };
   if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
  }
  disconnectedCallback(){this.observer?.disconnect();}
 });
}
(function(){
 const init=()=>{
  const params=new URLSearchParams(location.search);
  if(params.get('inquiry')!=='measurements') return;
  const form=document.getElementById('ContactForm');
  const title=(params.get('product')||'').slice(0,250);
  const path=params.get('product_url')||'';
  if(!form||!title||!/^\/products\/[a-zA-Z0-9_-]+(?:\?variant=\d+)?$/.test(path)) return;
  const selection=(params.get('selection')||'').slice(0,250);
  const summary=document.createElement('div');
  summary.className='wdlt-inquiry-summary';
  const heading=document.createElement('p'); heading.textContent='Request measurements'; heading.className='wdlt-inquiry-heading';
  const product=document.createElement('p'); product.textContent=title;
  const option=document.createElement('p'); option.textContent=selection;
  const view=document.createElement('a'); view.href=path; view.textContent='View product';
  summary.append(heading,product); if(selection) summary.append(option); summary.append(view);
  form.prepend(summary);
  const query=form.querySelector('#ContactFormQueryType'); if(query)query.value='Product Fit';
  const reason=form.querySelector('.reason'); if(reason)reason.value='Product Fit';
  const topic=form.querySelector('#dLabel'); if(topic){topic.textContent='Product Fit';topic.closest('.dropdown').hidden=true;}
  [['Product',title],['Selected options',selection],['Product URL',location.origin+path]].forEach(([name,value])=>{
   const input=document.createElement('input');input.type='hidden';input.name='contact['+name+']';input.value=value;form.append(input);
  });
  const message=form.querySelector('#ContactForm-body');
  if(message){message.placeholder='Which measurements would you like to know?';const label=form.querySelector('label[for="ContactForm-body"]');if(label)label.textContent='Your question';}
  const send=form.querySelector('button[type="submit"]');if(send)send.textContent='Send request';
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
